import selectRenderPlugin from './select';
import cascaderRenderPlugin from './cascader';
import radioGroupRenderPlugin from './radioGroup';
import checkBoxGroupRenderPlugin from './checkboxGroup';
import timePickerRenderPlugin from './timePicker';
import datePickerRenderPlugin from './datePicker';
import rangePickerRenderPlugin from './rangePicker';
import switchRenderPlugin from './switch';
import sliderRenderPlugin from './slider';
import rateRenderPlugin from './rate';
import uploadRenderPlugin from './upload';
import popEditRenderPlugin from './popEdit';
import imageUploadRenderPlugin from './imageUpload';
import transferPlugin from './transfer';

export {
  selectRenderPlugin,
  cascaderRenderPlugin,
  radioGroupRenderPlugin,
  checkBoxGroupRenderPlugin,
  timePickerRenderPlugin,
  datePickerRenderPlugin,
  rangePickerRenderPlugin,
  switchRenderPlugin,
  sliderRenderPlugin,
  rateRenderPlugin,
  uploadRenderPlugin,
  popEditRenderPlugin,
  imageUploadRenderPlugin,
  transferPlugin
}

export default [
  selectRenderPlugin, 
  cascaderRenderPlugin, 
  radioGroupRenderPlugin, 
  checkBoxGroupRenderPlugin, 
  timePickerRenderPlugin,
  datePickerRenderPlugin,
  rangePickerRenderPlugin,
  switchRenderPlugin,
  sliderRenderPlugin,
  rateRenderPlugin,
  uploadRenderPlugin,
  popEditRenderPlugin,
  imageUploadRenderPlugin,
  transferPlugin
];